<db-dialog-wrapper [dialog]="this" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading" [width]="'500px'" [height]="'223px'">
  <div class="db-change-payment-method">
    <div class="db-change-payment-method__update">
      <h3 *ngIf="changeEvent === 'changeFromPayPal'">{{'text_changePaymentMethodFromPaypalTitle' | dbText}}</h3>
      <h3 *ngIf="changeEvent !== 'changeFromPayPal'">{{'text_changePaymentMethodTitle' | dbText}}</h3>
      <p *ngIf="changeEvent === 'changeFromPayPal'" [innerHTML]="'text_changeMainPaymentMethodDesc' | dbText"></p>
      <p *ngIf="changeEvent === 'extra'" [innerHTML]="'text_changePaymentMethodDesc' | dbText"></p>
      <p *ngIf="changeEvent === 'main'" [innerHTML]="'text_changeMainPaymentMethodCardDesc' | dbText"></p>
      <div class="db-change-payment-method-buttons">
        <a class="ds-btn" (click)="close_window()"><span>{{'text_cancel' | dbText}}</span></a>
        <a class="ds-btn-blue" *ngIf="changeEvent !== 'changeFromPayPal'" [ngClass]="{'ds-btn-disabled': loading}"  (click)="changePaymentMethod(paymentMethod.id)">
          <span *ngIf="!loading">{{'text_confirmMakePrimary.button' | dbText}}</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </a>
        <a class="ds-btn-blue" *ngIf="changeEvent === 'changeFromPayPal'" [ngClass]="{'ds-btn-disabled': loading}"  (click)="changePayPalToCard(paymentMethod.id)">
          <span *ngIf="!loading">{{'text_confirmMakePrimary.button' | dbText}}</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </a>
      </div>
    </div>

  </div>
</db-dialog-wrapper>
